<template>
<div class="chapter">
<div class="inner_page">
<div class="div_autre">
<div class="pre" id="pre-001">
<h1 class="pre_tit"><span><a id="page_VIII">PUBLISHER’S NOTE REGARDING THIS DIGITAL EDITION</a></span></h1><a id="page_VIII">
</a><div class="dev"><a id="page_VIII">
<p class="txt_courant_centre"><i>Due to limitations regarding digital rights, the RSV Scripture text is linked to but does not appear in this digital edition of this Ancient Christian Commentary on Scripture volume as it does in the print edition. We apologize for any inconvenience this may cause.</i></p>
</a><a id="page_IX"> </a></div><a id="page_IX">
</a></div><a id="page_IX">
</a></div><a id="page_IX">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// pre2.vue?883e1276